import animateOnScroll from "./animateOnScroll"

//animate elements
/*---------------
Notes
-----------------
Offset:
- .5 means half of the element is visible before triggering
- 1 means 100% of the element should be visible
- 0 would be if any part of the element is visible 
CSS animations:
- make sure that the transformX/Y is not too large otherwise it will take forever to animate in
*/
animateOnScroll([
    { selector: ".fade-in", offset: 0, multiple: true },
    { selector: ".fade-in-bottom", offset: 0, multiple: true },
    { selector: ".custom-border-wrapper", offset: 0, multiple: true },
    { selector: ".fade-in-bl", offset: 0, multiple: true }
]);

// Set transform-origin for each hex group to its own center
window.addEventListener("load", () => {
    const svg = document.querySelector("#Hexagons");
    if (!svg) return;
    
    const groups = svg.querySelectorAll(".hex-group");
    groups.forEach((group) => {
        // Get the bounding box of the group in SVG coordinates
        const bbox = group.getBBox();
        const centerX = bbox.x + bbox.width / 2;
        const centerY = bbox.y + bbox.height / 2;
        
        // For SVG elements, we can use CSS transform-origin with pixel values
        // or convert to percentage. Using pixel values is more reliable.
        // The bbox coordinates are already in the SVG coordinate system
        group.style.transformOrigin = `${centerX}px ${centerY}px`;
    });
});